/**
 * Global configuration for the Balut Island Portal
 */

const getEnv = (key: string, fallback: string): string => {
  try {
    const env = (typeof process !== 'undefined' ? process.env : null) || (import.meta as any).env || {};
    return env[key] || fallback;
  } catch (e) {
    return fallback;
  }
};

export const CONFIG = {
  USE_REAL_BACKEND: true,
  
  SUPABASE_URL: getEnv('SUPABASE_URL', 'https://udcknrnseztmsjslzgcr.supabase.co'),
  SUPABASE_ANON_KEY: getEnv('SUPABASE_ANON_KEY', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVkY2tucm5zZXp0bXNqc2x6Z2NyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAwMDM2MDIsImV4cCI6MjA4NTU3OTYwMn0.SP8F_0yCfNFuLZoHOg05uqwatdbR76C9BDFAYnl1wHk'),

  ADMIN_PASSCODE: getEnv('ADMIN_PASSCODE', 'joGbej-nefpib-jupco8'),

  SIMULATED_LATENCY: 800,
  STORAGE_KEY: 'balut_island_v1_db',

  ENABLE_FORM_HONEYPOT: true,
  MAX_INQUIRY_RATE_MS: 5000,
};